import "./Footer.css";

import AT_BIO_902 from "../../Media/footer/AT_BIO_902.png";
import Bio_Austria from "../../Media/footer/Bio_Austria.png";

export default function Footer() {
	return (
		<div className="footer">
			<div className="contactDataContainer">
				<h4 className="contactDataHeader">WILLIS WEINVIERTLER BIO HONIG</h4>
				<p className="contactData">
					Familie Schild
					<br />
					2133 Hagenberg 104
					<br />
					<a className="contactDataLink" href="tel:+43 664 4209342">+43 664 4209342</a>
					<br />
					<a className="contactDataLink" href="mailto:willisBIOhonig@aon.at">willisBIOhonig@aon.at</a>
					<br />
					<a className="contactDataLink" href="https://www.instagram.com/willisweinviertlerbiohonig/" target="_blank">Instagram</a>
				</p>
			</div>

			<div className="certificateContainer">
				<div style={{ flex: 1 }} />

				<img className="certificateImg" src={AT_BIO_902} />
				<img className="certificateImg" src={Bio_Austria} />

				<p className="year">@2026</p>
			</div>
		</div>
	);
}